import { Logo } from "@caint/design-system";
import { useState } from "react";

export interface LoginProps {
  /** Login real (JWT). O perfil vem do servidor. Retorna erro ou null. */
  onSignIn: (matricula: string, senha: string) => Promise<string | null>;
  /** Aviso neutro exibido acima do formulário (ex.: sessão expirada). */
  aviso?: string;
}

/** Login por matrícula + senha (JWT). O servidor reconhece o perfil do usuário. */
export function Login({ onSignIn, aviso }: LoginProps) {
  const [matricula, setMatricula] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  const entrar = async () => {
    if (entrando) {
      return;
    }
    setEntrando(true);
    setErro(null);
    const msg = await onSignIn(matricula.trim().toLowerCase(), senha);
    if (msg) {
      setErro(msg);
      setEntrando(false);
    }
    // sucesso: o componente é desmontado pelo App ao autenticar
  };

  const campoEscuro = {
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.15)",
    color: "#fff",
  };

  return (
    <div className="m-app" style={{ background: "var(--surface-ink)" }}>
      <div
        className="m-body"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding:
            "calc(env(safe-area-inset-top, 0px) + 56px) 24px calc(env(safe-area-inset-bottom, 0px) + 32px)",
          color: "#fff",
        }}
      >
        <Logo size={56} variant="reverse" />
        <div
          style={{
            fontSize: 12,
            fontFamily: "var(--font-mono)",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: "var(--teal-300)",
            marginTop: 28,
          }}
        >
          Instrumento Unificado · v4.0
        </div>
        <h1
          style={{ fontSize: 30, fontWeight: 800, letterSpacing: "-0.04em", lineHeight: 1.05, marginTop: 10 }}
        >
          Avaliação de maturidade &amp; risco
        </h1>
        <p style={{ color: "rgba(255,255,255,0.7)", fontSize: 15, marginTop: 12, lineHeight: 1.45 }}>
          CAINT · EMSERH — Comissão para Avaliação Interna da Maturidade. Unidades obstétricas do Maranhão.
        </p>

        {aviso && (
          <output
            style={{
              display: "block",
              color: "#CFF3E6",
              background: "rgba(45,178,138,0.16)",
              border: "1px solid rgba(45,178,138,0.35)",
              borderRadius: 10,
              padding: "9px 12px",
              fontSize: 13,
              marginTop: 20,
            }}
          >
            {aviso}
          </output>
        )}

        <div style={{ marginTop: 28 }}>
          <div className="m-field">
            <label style={{ color: "rgba(255,255,255,0.6)" }} htmlFor="usuario">
              E-mail
            </label>
            <input
              id="usuario"
              className="m-input"
              value={matricula}
              onChange={(e) => setMatricula(e.target.value)}
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              inputMode="email"
              style={campoEscuro}
            />
          </div>
          <div className="m-field">
            <label style={{ color: "rgba(255,255,255,0.6)" }} htmlFor="senha">
              Senha
            </label>
            <input
              id="senha"
              className="m-input"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete="current-password"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  void entrar();
                }
              }}
              style={campoEscuro}
            />
          </div>
        </div>
        {erro && (
          <p
            role="alert"
            style={{
              color: "#FFD9DE",
              background: "rgba(208,107,124,0.18)",
              border: "1px solid rgba(208,107,124,0.35)",
              borderRadius: 10,
              padding: "9px 12px",
              fontSize: 13,
              marginTop: 16,
            }}
          >
            {erro}
          </p>
        )}
        <button
          type="button"
          className="m-btn primary"
          style={{ marginTop: 24, opacity: entrando ? 0.7 : 1 }}
          disabled={entrando}
          onClick={() => void entrar()}
        >
          {entrando ? "Entrando…" : "Entrar"}
        </button>
        <p style={{ textAlign: "center", color: "rgba(255,255,255,0.4)", fontSize: 12, marginTop: 16 }}>
          Acesso restrito · GQA · GGO · NCIG · AUDIN · Coordenação
        </p>
      </div>
    </div>
  );
}
